import SurvivorMultipleContainer from './SurvivorMultipleContainer';
export default SurvivorMultipleContainer;